"use client"

import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Col, Row, Skeleton } from "antd"
import { useTranslation } from "react-i18next"

const ComboDealsSkeleton = () => {

  const { t } = useTranslation()
  const isDesktop = useIsDesktop()

  return (
    <Row
      style={{ marginBottom: '3rem' }}
    >
      <Col span={24} style={{ marginBottom: '1rem' }}>
        <Row>
          <Title
            level={3}
            style={{
              margin: 0,
              marginBottom: '0.5rem'
            }}
          >
            {t("deals.combo_title")}
          </Title>
        </Row>
        <Row>
          <Text type='secondary'>
            {t("deals.combo_desc")}
          </Text>
        </Row>
      </Col>
      <Col span={24}>
        <Skeleton
          paragraph={false}
          styles={{
            title: {
              margin: 0,
              height: !isDesktop ? "10rem" : "26rem"
            }
          }}
          active
        />
      </Col>
    </Row>
  )
}

export default ComboDealsSkeleton